import Icon from "@ant-design/icons";
import Image from "next/image";
import React from "react";

import type { ComponentProps, SVGProps } from "react";

export const G47Icon = (
  <Image width="16" height="16" alt="g47" className="opacity-50" src="/images/docks/G47.svg" />
);

const DockSvg: React.FC<SVGProps<SVGSVGElement>> = props => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 87 76" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M71.099 6H15.7933C14.3787 6 13.1563 6.9882 12.8599 8.37141L8.86805 27H78.0242L74.0324 8.37141C73.736 6.9882 72.5136 6 71.099 6ZM15.7933 0C11.5495 0 7.88228 2.9646 6.99307 7.11423L2.27879 29.1142C1.07823 34.7168 5.34922 40 11.079 40H75.8132C81.543 40 85.814 34.7169 84.6135 29.1142L79.8992 7.11424C79.01 2.9646 75.3428 0 71.099 0H15.7933ZM15.9531 43C10.1986 43 5.25426 47.0849 4.16858 52.736L0 74.434L5.89225 75.566L10.0608 53.868C10.6037 51.0424 13.0759 49 15.9531 49H70.9392C73.8164 49 76.2886 51.0424 76.8314 53.868L81 75.566L86.8922 74.434L82.7237 52.736C81.638 47.0849 76.6936 43 70.9392 43H15.9531Z"
      />
    </svg>
  );
};

const DockIcon: React.FC<ComponentProps<typeof Icon>> = props => (
  <Icon {...props} component={DockSvg} />
);

export default DockIcon;
